<template>
    <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item, index) in $route.meta.arr" :key="index">
            <router-link v-if="item.url" :to="item.url">{{
              item.name
            }}</router-link>
            <a v-else>
              {{ item }}
            </a>
          </el-breadcrumb-item>
        </el-breadcrumb>
</template>
<script>
export default {
    data() {
        return {
            breadList:[]
        }
    },
    created(){
    },
    methods:{
     
    },
    watch:{
        // '$route':function(val) {
        //     console.log(val);
        // }
    }
}
</script>
<style lang="">
    
</style>